/**
 * 定价档位 —— 各页面唯一真源。
 *
 * 同一条 product_pricing 表被 exe 和 AIP 共用，所以字段改为
 * 小/中/大周期，不再把“天数”写进字段名：
 *   - priceSmallCycle
 *   - priceMediumCycle
 *   - priceLargeCycle
 *
 * exe：30 / 90 / 365 天
 * AIP：90 / 180 / 365 天
 */

/** AIP 插件（公共产品）档位：小/中/大 = 90/180/365 天 */
export const AI_PLUGIN_TIERS = [
    { days: 90, priceKey: 'priceSmallCycle' },
    { days: 180, priceKey: 'priceMediumCycle' },
    { days: 365, priceKey: 'priceLargeCycle' },
]

/** exe 产品档位：小/中/大 = 30/90/365 天 */
export const EXE_TIERS = [
    { days: 30, priceKey: 'priceSmallCycle' },
    { days: 90, priceKey: 'priceMediumCycle' },
    { days: 365, priceKey: 'priceLargeCycle' },
]

export function pickTierPrice(prices, priceKey) {
    return prices?.[priceKey] ?? 0
}
